export const SET_TEXT_STRINGS = 'SET_TEXT_STRINGS';
